import React, { Component } from 'react';
import removeIconPng from '../../../images/remove.png';
import PropTypes from 'prop-types';
import DocumentLink from '../document/DocumentLink';
import './FilesUploadedViewer.css';

class FilesUploadedViewer extends Component {
  static propTypes = {
    documents: PropTypes.array.isRequired,
    showLink: PropTypes.bool,
    title: PropTypes.string,
    onDocumentRemove: PropTypes.func,
  };

  static defaultProps = {
    showLink: false,
  };

  handleDocumentRemove = (event, documentId) => {
    event.preventDefault();
    if (this.props.onDocumentRemove !== undefined) {
      this.props.onDocumentRemove(documentId);
    }
  };

  render() {
    return (
      <div className="files-uploaded-viewer">
        {this.props.documents.length > 0 && this.props.title !== undefined && (
          <div className="viewer-title">
            <div>{this.props.title}</div>
          </div>
        )}

        <ul>
          {this.props.documents.map((element) => {
            return (
              <li key={element.id}>
                <div>
                  <div>
                    <DocumentLink
                      showIcon={false}
                      showLink={this.props.showLink}
                      url={element.document.url}
                    />
                  </div>
                  <div>
                    <img
                      src={removeIconPng}
                      alt="remove"
                      onClick={(event) =>
                        this.handleDocumentRemove(event, element.id)
                      }
                    />
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default FilesUploadedViewer;



// WEBPACK FOOTER //
// ./src/components/shared/files/FilesUploadedViewer.js